<template>
  <qx-card-form title="预付款标准比例设置">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="160px"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '预付比例',
            value: 'advanceCharge',
            type: 'input',
          },
        ],
        rules: {
          advanceCharge: [ // 预付比例
            { required: true, message: '请输入预付比例', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async sub () {
      const result = {};
      const formData = await this.$refs.baseForm.sub();
      Object.keys(formData).forEach((key) => {
        result[`creditRatingRules_0.${key}`] = formData[key];
      });
      return result;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    async init (data = {}) {
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
